import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/**
 * Internal dependencies
 */

import { renderAsRenderProps } from './utils';
/**
 * VisuallyHidden component to render text out non-visually
 * for use in devices such as a screen reader.
 */

function VisuallyHidden(_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'div' : _ref$as,
      props = _objectWithoutProperties(_ref, ["as"]);

  return renderAsRenderProps(_objectSpread({
    as: as,
    className: 'components-visually-hidden'
  }, props));
}

export default VisuallyHidden;